module.exports = __webpack_public_path__ + "static/media/info03_Documentos_adjuntos.8e3f9ed2.png";